import Compra from './componentes/Compra.vue';
import CompraLista from './componentes/Lista.vue';
import CompraRelatorio from './componentes/Relatorio.vue';

export default {
  path: 'compra',
  component: Compra,
  meta: { auth: true },
  children: [
    {
      path: 'compra',
      component: CompraLista,
      name: 'compra.compra',
    },
    {
      path: ':id/relatorio',
      component: CompraRelatorio,
      name: 'compra.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/compra/rotas.js